'use client';

import { ExternalToast, toast } from 'sonner';

type SonnerLoadingV2Props = {
    /**Callback close loading sonner */
    close: VoidFunction;
};

/**loading sonner */
export const sonnerLoading = (
    message: string | React.ReactNode,
    data?: ExternalToast
) => {
    const _id = toast.loading(message, {
        closeButton: false,
        ...(data ?? {}),
    });

    return _id;
};

/**loading sonner with dissmiss function */
export const sonnerLoadingV2 = (
    message: string | React.ReactNode,
    data?: ExternalToast
): SonnerLoadingV2Props => {
    const _id = toast.loading(message, {
        closeButton: false,
        ...(data ?? {}),
    });

    const onClose = () => {
        toast.dismiss(_id);
    };

    return {
        close: onClose,
    };
};
